import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class OperationService extends Service {
	constructor(injector: Injector) {
		super("Operation", injector);
	}

	autoPlan() {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/AutoPlan`, {});
	}

	// The API reads the operation id as toolOrderStageId (older name); it's sent under both names so any API version
	// updates the right operation - without it every change silently went to operation 0.
	changeEstimates(data: { estimatedRunTime: number | null, estimatedSetupTime: number | null, estimatedStartDate: string | null, operationId: number }) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/ChangeEstimates`, { ...data, toolOrderStageId: data.operationId });
	}

	changeMachine(data: { machineId: number | null, operationId: number }) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/ChangeMachine`, { ...data, toolOrderStageId: data.operationId });
	}

	changeOperator(data: { assignedUserProfileId: number | null, operationId: number }) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/ChangeOperator`, { ...data, toolOrderStageId: data.operationId });
	}

	changePriority(data: { operationId: number, priority: number }) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/ChangePriority`, { ...data, toolOrderStageId: data.operationId });
	}

	completeStage(id: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/CompleteStage/${id}`, {});
	}

	forToolOrder(toolOrderId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForToolOrder/${toolOrderId}`);
	}

	plannerByMachine() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/PlannerByMachine`);
	}

	plannerByMachineForDate(date: Date) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/PlannerByMachine/${date.toDateString()}`);
	}

	plannerByOperator() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/PlannerByOperator`);
	}

	plannerByOperatorForDate(date: Date) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/PlannerByOperator/${date.toDateString()}`);
	}

	plannerByProductionTool() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/PlannerByProductionTool`);
	}

	plannerByProductionToolForDate(date: Date) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/PlannerByProductionTool/${date.toDateString()}`);
	}

	startStage(id: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/StartStage/${id}`, {});
	}

	togglePause(id: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/TogglePause/${id}`, {});
	}
}
